import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ApplFeeStatusModalUI from './ApplFeeStatusModalUI.js'

class ApplFeeStatusModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      applFeeStatus: '',
      applFeeStatusError: null,
    }
  }

  render() {
    let applFeeStatusList = [
      { key: 'unpaid', value: 'Unpaid' },
      { key: 'waived', value: 'Waived' },
      { key: 'paid', value: 'Paid' },
    ]
    return (
      <ApplFeeStatusModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        applFeeStatus={this.state.applFeeStatus}
        onApplFeeStatusChange={(event) => { this.setState({ applFeeStatus: event.target.value }) }}
        applFeeStatusError={this.state.applFeeStatusError}
        setApplFeeStatusError={(error) => { this.setState({ applFeeStatusError: error }) }}
        applFeeStatusList={applFeeStatusList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/applicationFee/status`,
      this.onSubmitCallback, {
      applFeeStatus: this.state.applFeeStatus
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(ApplFeeStatusModalSF)
